/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { INosBusinessSignUpResources } from '../nos-business-sign-up.props.autogenerated';

export interface IBusinessSignUpTermsConditionsInputProps {
    id: string;
    name: string;
    key: string;
    type: string;
    className: string;
    onChange?(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
    isVatCheckFirstClickDone?: boolean;
    resources: INosBusinessSignUpResources;
    isAcceptedTermsAndConditions: boolean;
    isSubmittedPressed: boolean;
}

export const SignUpTermsConditions: React.FC<IBusinessSignUpTermsConditionsInputProps> = ({
    id,
    name,
    key,
    type,
    resources,
    className,
    onChange,
    isAcceptedTermsAndConditions,
    isSubmittedPressed
}) => {
    return (
        <React.Fragment>
            <div className='col-12' key={key}>
                <div className={`${className}__disclaimer`}>
                    <input
                        className='ms-form__input-checkbox'
                        type={type}
                        id={id}
                        name={name}
                        checked={isAcceptedTermsAndConditions}
                        onChange={onChange}
                    />
                    <label className='ms-form__label-checkbox' htmlFor='termsAndConditions'>
                        {<span dangerouslySetInnerHTML={{ __html: resources.termsAndConditions }} />}
                    </label>
                </div>
            </div>
            {!isAcceptedTermsAndConditions && isSubmittedPressed && (
                <div className='col-12'>
                    <div className='ms-alert ms-alert-danger mt-m'>{resources.termsAndConditionsValidate}</div>
                </div>
            )}
        </React.Fragment>
    );
};

export default SignUpTermsConditions;
